export default {
  name: "addressvalidation",
  component() {
    return {
      googleRating: null,
      googlePlaceId: null,
      isNewZealand: false,
      debounceTimer: null,
      sessionToken: null,
      init() {
        if (!window.googlePlacesInitialized) {
          window.googlePlacesInitialized = {
            fields: new Set(),
            sessionToken: null
          };
        }
        
        this.setupGooglePlacesAutocomplete();
      },
      
      debounce(func, wait) {
        return (...args) => {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(() => {
            func.apply(this, args);
          }, wait);
        };
      },
      
      getRating () {
        const savedData = localStorage.getItem("rating");
        this.googleRating = savedData;
        return savedData ? savedData : null;
      },
      
      storeRating(rating) {
        localStorage.setItem("rating", rating);
        this.googleRating = rating;
      },
      
      createSessionToken() {
        if (typeof google !== "undefined" && google.maps && google.maps.places) {
          return new google.maps.places.AutocompleteSessionToken();
        }
        return null;
      },

      setupGooglePlacesAutocomplete() {
        const addressField = this.$refs.address_field;
        if (!addressField) {
          return;
        }
        
        const fieldId = addressField.id || addressField.getAttribute('name') || Date.now().toString();
        
        if (addressField.getAttribute('data-autocomplete-initialized') === 'true' || 
            window.googlePlacesInitialized?.fields.has(fieldId)) {
          console.log("Field already initialized, skipping:", fieldId);
          return;
        }
        
        if (window.googlePlacesInitialized) {
          window.googlePlacesInitialized.fields.add(fieldId);
        }
        
        const originalAddEventListener = HTMLInputElement.prototype.addEventListener;
 
        addressField.addEventListener = function(type, listener, options) {
          if (type === 'input' || type === 'keyup' || type === 'keydown') {
            let lastEventTime = 0;
            const throttleDelay = 1000; 
            const throttledListener = function(event) {
              const now = Date.now();
              if (now - lastEventTime >= throttleDelay) {
                lastEventTime = now;
                return listener.apply(this, arguments);
              }
            };
            
            return originalAddEventListener.call(this, type, throttledListener, options);
          }
          
          return originalAddEventListener.call(this, type, listener, options);
        };
        
        const checkGoogleLoaded = setInterval(() => {
          if (typeof google !== "undefined" && google.maps && google.maps.places) {
            clearInterval(checkGoogleLoaded);
            
            if (!window.googlePlacesInitialized.sessionToken) {
              window.googlePlacesInitialized.sessionToken = this.createSessionToken();
              console.log("Created global session token:", window.googlePlacesInitialized.sessionToken);
            }
            
            this.sessionToken = window.googlePlacesInitialized.sessionToken;
            
            if (!google.maps.places.__throttled) {
              const originalGetPredictions = google.maps.places.AutocompleteService.prototype.getPlacePredictions;
              const self = this;
              
              let lastCallTime = 0;
              const throttleDelay = 1000;
              
              google.maps.places.AutocompleteService.prototype.getPlacePredictions = function(request, callback) {
                if (!request.input || request.input.length < 3) {
                  return;
                }
                
                const now = Date.now();
                if (now - lastCallTime < throttleDelay) {
                  return;
                }
                
                lastCallTime = now;
                
                if (window.googlePlacesInitialized && window.googlePlacesInitialized.sessionToken) {
                  request.sessionToken = window.googlePlacesInitialized.sessionToken;
                }
                
                return originalGetPredictions.call(this, request, callback);
              };
              
              google.maps.places.__throttled = true;
            }
            const autocomplete = new google.maps.places.Autocomplete(
              addressField,
              {
                types: ["geocode"],
                componentRestrictions: { country: ["au", "nz"] },
                fields: ['address_components'],
                sessionToken: this.sessionToken
              }
            );
  
            addressField.setAttribute('data-autocomplete-initialized', 'true');

            autocomplete.addListener("place_changed", () => {
              const place = autocomplete.getPlace();
              const addressComponents = place.address_components;
              let province = null;

              this.isNewZealand = addressComponents.some(
                (item) => item.types.includes("country") && item.long_name === "New Zealand"
              );

              addressComponents.forEach((component) => {
                if (component.types.includes("locality")) {
                  if (this.$refs.city) this.$refs.city.value = component.long_name;
                } 
                else if (component.types.includes("administrative_area_level_1")) {
                  if (this.$refs.province) this.$refs.province.value = component.long_name;
                  province = component;
                } 
                else if (component.types.includes("postal_code")) {
                  if (this.$refs.zip) this.$refs.zip.value = component.long_name;
                } 
                else if (component.types.includes("country")) {
                  if (this.$refs.country) {
                    this.$refs.country.value = component.long_name;
                    const event = new Event("change", { bubbles: true });
                    this.$refs.country.dispatchEvent(event);
                    if (province && this.$refs.province) {
                      this.$refs.province.value = province.long_name;
                    }
                  }
                }
              });
              
              const oldToken = window.googlePlacesInitialized.sessionToken;
              window.googlePlacesInitialized.sessionToken = this.createSessionToken();
              console.log("Place selected. Replaced global token:", oldToken, "with:", window.googlePlacesInitialized.sessionToken);
            });
          } else {
            console.log("Waiting for Google Maps API...");
          }
        }, 1000);
      }
    };
  },
};
